export const clientId = "smx-sds-mgmt";
export const sdsManagementPath = "/sds-management";
